import { Component, OnInit } from '@angular/core';
import { JaldeeVerifyLevelService } from 'src/app/services/jaldee-verify-level.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';

@Component({
  selector: 'app-update-verify-level',
  templateUrl: './update-verify-level.component.html',
  styleUrls: ['./update-verify-level.component.css']
})
export class UpdateVerifyLevelComponent implements OnInit {
  data: any;
  sessionId: any = {};
  verifyLevel: any;
  configData: any = {};
  verifyLevels: any;
  currentDetails: any;
  viewCurrentLevelInfo = true;
  btnText = 'SAVE';
  verifyForm: UntypedFormGroup;
  updateLevelName: any;
  privateNotes: any;
  api_error: any;
  api_success: string;
  privateNote: any;
  paymentDoneBy: any;
  mode = 'Update';

  verificationlogArray: any = [];
  paymentlogArray: any = [];
  privateNotelogArray: any = [];
  accountType: any;
  id: any;
  jaldeeverifyLevels: any = [];
  configJaldeeVerifyLevels: any = [];
  btndisabled = false;

  constructor(private jaldeeverifyService: JaldeeVerifyLevelService, private activatedRoute: ActivatedRoute,
    private router: Router, private commonService: CommonfilterService, private formbuilder: UntypedFormBuilder,
    private datepipe: DateFormatPipe) {

    this.createForm();


    this.activatedRoute.params.subscribe(params => {
      if (params['type']) {
        this.jaldeeverifyService.setTypeofAccount(params['type']);

      }
      if (params['id']) {
        if (params['type'] === 'account') {
          this.accountType = params['type'];
          this.id = params['id'];
          this.jaldeeverifyService.setAccountDetails(this.id);
          this.getCurrentLevelDetailsofAccount(this.id);
        } else if (params['type'] === 'corporate') {
          this.id = params['id'];
          this.accountType = params['type'];
          this.jaldeeverifyService.setCorporateId(this.id);
          this.getCurrentLevelDetailsofCorporate(this.id);
        }
      } else {

        this.accountType = this.jaldeeverifyService.getTypeofAccount();
        if (this.accountType === 'corporate') {
          this.id = this.jaldeeverifyService.getCorporateId();
          this.getCurrentLevelDetailsofCorporate(this.id);
        } else if (this.accountType === 'account') {
          this.id = this.jaldeeverifyService.getAccountDetails();
          this.getCurrentLevelDetailsofAccount(this.id);
        }
      }

    });



  }

  verifyFormErrors = {
    'verifiedOn': '',
    'verifyLink': '',
    'verifiedNote': '',
    'verifiedBy': ''

  };
  ValidationMessages = {
    'verifiedOn': {
      'required': 'Verified On  is Required',
    },
    'verifyLink': {
      'required': 'Verification Link  is Required'
    },
    'verifiedNote': {
      'required': 'Verification Note  is Required',

    },
    'verifiedBy': {
      'required': 'Verified By  is Required',
    },
  };

  removeVerifyLevel(currentLevel, jaldeeverifyLevels) {
    jaldeeverifyLevels.forEach((level, index) => {
      if (level.value === currentLevel) {
        jaldeeverifyLevels.splice(index, 1);
      }
    });
    this.verifyLevels = jaldeeverifyLevels;

  }
  getCurrentLevelDetailsofAccount(accountId) {
    this.jaldeeverifyService.getCurrentLevelDetailsofAccount(accountId)
      .subscribe(res => {
        this.setCurrentDetails(res);

      });
  }
  getCurrentLevelDetailsofCorporate(corporateId) {
    this.jaldeeverifyService.getCurrentLevelDetailsofCorporate(corporateId)
      .subscribe(res => {
        this.setCurrentDetails(res);

      });

  }
  getCorrectDateAndTimeFormat(dateVal) {
    return this.datepipe.simpledateFormatWithTime(dateVal);
  }

  setCurrentDetails(res) {
    this.currentDetails = res;
    this.verifyLevel = this.currentDetails.verifiedLevel;
    if (this.currentDetails['verificationChangeLog']) {
      const verificationlog = this.currentDetails.verificationChangeLog;
      this.verificationlogArray = verificationlog.changeLog;
    }
    if (this.currentDetails['paymentChangeLog']) {
      const paymentlog = this.currentDetails.paymentChangeLog;
      this.paymentlogArray = paymentlog.changeLog;
    }

    if (this.currentDetails['privateNoteLog']) {
      const privateNote = this.currentDetails.privateNoteLog;
      this.privateNotelogArray = privateNote.privateNote;
    }

    this.commonService.getConfigData()
      .subscribe(response => {
        this.configData = response;
        //this.configJaldeeVerifyLevels = this.configData.verifyLevel;
        this.jaldeeverifyLevels = this.configData.verifyLevel;
        this.removeVerifyLevel(this.verifyLevel, this.jaldeeverifyLevels);

      });



  }
  ngOnInit() {


  }
  createForm() {
    this.verifyForm = this.formbuilder.group({
      accountId: this.id,
      corpId: this.id,
      verifiedLevel: this.verifyLevel,
      verificationDetails: this.formbuilder.group({
        verifiedOn: ['', [Validators.required]],
        verifyLink: ['', [Validators.required]],
        verifiedNote: ['', [Validators.required]],
        verifiedBy: ['', [Validators.required]],
      }),
      paymentDetails: this.formbuilder.group({
        totalCharged: 0.0,
        discountApplied: 0.0,
        totalCollected: 0.0,
        paymentMode: 'None',
        paymentDoneBy: ''
      }),
      privateNote: '',
    });


  }
  updateCurrentLevel() {
    this.api_error = '';
    this.api_success = '';
    this.viewCurrentLevelInfo = false;
    this.btnText = 'Update';
    this.mode = 'Update';
    this.verifyLevel = this.currentDetails.verifiedLevel;

    this.verifyForm.patchValue({
      accountId: this.currentDetails.accountId,
      verifiedLevel: this.currentDetails.verifiedLevel,
      privateNote: ''

    });

    this.verifyForm.get('verificationDetails').patchValue({
      verifyLink: this.currentDetails.verificationDetails.verifyLink || '',
      verifiedNote: this.currentDetails.verificationDetails.verifiedNote || '',
      verifiedBy: this.currentDetails.verificationDetails.verifiedBy || '',
      verifiedOn: this.currentDetails.verificationDetails.verifiedOn || ''

    });
    this.verifyForm.get('paymentDetails').patchValue({
      totalCharged: this.currentDetails.paymentDetails.totalCharged || 0.0,
      discountApplied: this.currentDetails.paymentDetails.discountApplied || 0.0,
      totalCollected: this.currentDetails.paymentDetails.totalCollected || 0.0,
      paymentMode: this.currentDetails.paymentDetails.paymentMode || 'None',
      paymentDoneBy: this.currentDetails.paymentDetails.paymentDoneBy
    });


  }

  onCancel() {
    this.api_error = '';
    this.api_success = '';
    if (this.accountType === 'account') {
      this.getCurrentLevelDetailsofAccount(this.id);
    } else if (this.accountType === 'corporate') {
      this.getCurrentLevelDetailsofCorporate(this.id);
    }
    this.viewCurrentLevelInfo = true;
  }
  changeVerifyLevel(event) {


    this.mode = 'Save';
    this.viewCurrentLevelInfo = false;
    this.updateLevelName = event;
    this.verifyLevel = event;
    this.btnText = 'SAVE';
    if (this.accountType === 'corporate') {
      this.verifyForm.patchValue({
        corpId: this.id

      });
    } else if (this.accountType === 'account') {
      this.verifyForm.patchValue({
        accountId: this.id

      });

    }

    this.verifyForm.patchValue({
      verifiedLevel: event,
      privateNote: ''

    });

    this.verifyForm.get('verificationDetails').patchValue({
      verifyLink: '',
      verifiedNote: '',
      verifiedBy: '',
      verifiedOn: ''
    });
    this.verifyForm.get('paymentDetails').patchValue({
      totalCharged: 0.0,
      discountApplied: 0.0,
      totalCollected: 0.0,
      paymentMode: 'None',
      paymentDoneBy: ''
    });
    this.api_error = '';
    this.api_success = '';

  }
  verification() {

    this.api_error = '';
    this.api_success = '';
    const formData = this.verifyForm.value;
    // formData.accountId = this.id;
    formData.verifiedLevel = this.verifyLevel;
    if (this.accountType === 'corporate') {
      delete formData.accountId;
      formData.corpId = this.id;
      this.saveOrUpdateJaldeeVeriifcationOfCorporate(formData);
    } else if (this.accountType === 'account') {
      delete formData.corpId;
      formData.accountId = this.id;
      this.saveOrUpdateJaldeeVeriifcationOfAccount(formData);
    }

  }
  saveOrUpdateJaldeeVeriifcationOfCorporate(formData) {
    if (this.mode === 'Save') {
      this.btndisabled = true;
      this.jaldeeverifyService.saveVerificationForCorporate(formData)
        .subscribe(res => {
          this.btndisabled = false;
          this.api_success = 'Jaldee Verification of corporate done successfully ';
          setTimeout(() => {
            this.resetFields();
            this.getCurrentLevelDetailsofCorporate(this.id);
            this.viewCurrentLevelInfo = true;
          }, 1000);

        }, (error) => {
          this.api_error = error.error;
          this.btndisabled = false;

        });
    } else if (this.mode === 'Update') {
      this.btndisabled = true;
      this.jaldeeverifyService.updateVerificationForCorporate(formData)
        .subscribe(res => {
          this.api_success = 'Jaldee Verification updated successfully';
          this.btndisabled = false;
          setTimeout(() => {
            this.resetFields();
            this.getCurrentLevelDetailsofCorporate(this.id);
            this.viewCurrentLevelInfo = true;
          }, 1000);
        }, (error) => {
          this.api_error = error.error;
          this.btndisabled = false;

        });
    }

  }
  saveOrUpdateJaldeeVeriifcationOfAccount(formData) {

    if (this.mode === 'Save') {
      this.btndisabled = true;
      this.jaldeeverifyService.saveVerification(formData)
        .subscribe(res => {
          this.btndisabled = false;
          this.api_success = 'Jaldee Verification of an account  done successfully ';
          setTimeout(() => {
            this.resetFields();
            this.getCurrentLevelDetailsofAccount(this.id);
            this.viewCurrentLevelInfo = true;
          }, 1000);

        }, (error) => {
          this.btndisabled = false;
          this.api_error = error.error;

        });
    } else if (this.mode === 'Update') {
      this.btndisabled = true;
      this.jaldeeverifyService.updateVerification(formData)
        .subscribe(res => {
          this.btndisabled = false;
          this.api_success = 'Jaldee Verification updated successfully';
          setTimeout(() => {
            this.resetFields();
            this.getCurrentLevelDetailsofAccount(this.id);
          
            this.viewCurrentLevelInfo = true;
          }, 1000);
        }, (error) => {
          this.btndisabled = false;
          this.api_error = error.error;

        });
    }


  }
  getCorrectDate(dateval) {
    return this.datepipe.simpledateFormat(dateval);
  }
  resetFields() {
    this.verificationlogArray = [];
    this.paymentlogArray = [];
    this.privateNotelogArray = [];
  }

}